<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="autores"
      class="mb-4"
      hide-default-footer
    >
      <template v-slot:top>
        <v-row>
          <v-col>
            <span class="text-h6">Autores</span>
          </v-col>
          <v-col class="ml-auto text-right">
            <v-btn
              :block="xs"
              color="primary"
              class="mr-2"
              :disabled="validateTable"
              @click="newAuthor"
            >
              Añadir autor
            </v-btn>
            <!-- <v-btn :block="xs" color="secondary" @click="newAsesor">
              Añadir asesor
            </v-btn> -->
          </v-col>
        </v-row>

        <v-dialog v-model="dialog" persistent max-width="500px">
          <Worker v-model="working">
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-text-field
                  v-model="autor.dni"
                  label="Numero de Documento"
                  v-on:blur="buscar"
                  :rules="[rules.noEmpty, rules.onlyNum]"
                  ref="dni"
                  :error-messages="duplicate"
                ></v-text-field>
                <v-text-field
                  v-model="autor.nombres"
                  label="Nombres"
                  :disabled="disable"
                  :rules="[rules.noEmpty]"
                  ref="nombres"
                ></v-text-field>
                <v-text-field
                  v-model="autor.apellidos"
                  label="Apellidos"
                  :disabled="disable"
                  :rules="[rules.noEmpty]"
                  ref="apellidos"
                ></v-text-field>
                <v-text-field
                  v-model="autor.email"
                  label="Email"
                  :disabled="disable"
                  :rules="[rules.noEmpty, rules.email]"
                  :error-messages="exist"
                  ref="email"
                ></v-text-field>
                <v-text-field
                  v-model="autor.telefono"
                  label="Teléfono"
                  :disabled="disable"
                  :rules="[rules.noEmpty]"
                  ref="telefono"
                ></v-text-field>
                <v-autocomplete
                  v-model="instSelected"
                  :items="instituciones"
                  label="Institución"
                  :disabled="disable"
                  :rules="[rules.noEmpty]"
                  ref="instSelected"
                  :search-input.sync="search"
                ></v-autocomplete>
                <v-text-field
                  v-model="autor.institucion"
                  :search-input.sync="search"
                  label="Otra institución"
                  v-if="visible"
                  :disabled="disable"
                  :rules="[rules.noEmpty]"
                  ref="institucion"
                ></v-text-field>
                <v-text-field
                  v-model="autor.programa"
                  label="Programa"
                  :disabled="disable"
                  :rules="[rules.noEmpty]"
                  ref="programa"
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">
                  Cancelar
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="save"
                  :disabled="validate"
                >
                  Guardar
                </v-btn>
              </v-card-actions>
            </v-card>
          </Worker>
        </v-dialog>
      </template>
      <template v-slot:item.action="{ item }">
        <v-chip v-if="item.protected" color="primary" small text-color="white">
          <v-avatar left>
            <v-icon>mdi-account-outline</v-icon>
          </v-avatar>
          Autor principal
        </v-chip>
        <!-- <v-chip
          v-if="item.asesor"
          color="secondary"
          class="mr-2"
          small
          text-color="white"
        >
          <v-avatar left>
            <v-icon>mdi-account-outline</v-icon>
          </v-avatar>
          Asesor
        </v-chip> -->
        <v-icon
          v-if="!item.protected && !item.id_participante"
          small
          class="mr-2"
          @click="editAuthor(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon v-if="!item.protected" small @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-data>
        <div></div>
      </template>
    </v-data-table>
    <!-- <v-alert v-if="!validateTable" dense type="info">
      Solo puede añadir 10 autores como
      <strong>máximo</strong>
      .
    </v-alert> -->
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Worker from '@/components/Worker.vue'
import participanteService from '../services/participante'
import Swal from 'sweetalert2'
import { omit } from 'lodash'

export default {
  props: ['value', 'xs'],
  components: {
    Worker,
  },
  data() {
    return {
      dialog: false,
      working: false,
      // autores: [],
      index: -1,
      autor: {
        id_participante_poster: null,
        id_participante: null,
        dni: null,
        nombres: null,
        apellidos: null,
        email: null,
        telefono: null,
        institucion: null,
        programa: null,
        asesor: null,
      },

      instSelected: null,
      disable: true,
      visible: false,
      search: null,
      exist: null,
      duplicate: null,
    }
  },
  computed: {
    ...mapState('registro', [
      'headers',
      'defaultAutor',
      'rules',
      'instituciones',
    ]),
    formTitle() {
      return this.index === -1 ? 'Agregar' : 'Editar'
    },
    validate() {
      return (
        [
          'dni',
          'nombres',
          'apellidos',
          'email',
          'telefono',
          'institucion',
          'programa',
        ].some(e => !this.autor[e]) ||
        !/^\S+?@(?:[^\s.]+\.)+[^\s.]{2,}$/.test(this.autor.email) ||
        !/^([0-9])*$/.test(this.autor.dni) ||
        !!this.exist ||
        !!this.duplicate
      )
    },
    validateTable() {
      // return this.autores.some(e => e.asesor)
      return this.autores.length >= 10
    },
    autores() {
      return this.value
    },
    email() {
      return this.autor.email
    },
    dni() {
      return this.autor.dni
    },
  },

  watch: {
    autores() {
      this.$emit('input', this.autores)
    },
    instSelected(v) {
      if (v !== 'Otra') {
        this.autor.institucion = v
      }
      this.visible = v == 'Otra'
    },
    email() {
      this.exist = null
    },
    dni() {
      this.duplicate = null
    },
  },

  methods: {
    async buscar() {
      this.working = true
      participanteService
        .getParticipante(this.autor.dni)
        .then(data => {
          if (data)
            this.autor = Object.assign({ asesor: this.autor.asesor }, data)
          else {
            this.autor = Object.assign(this.autor, {
              id_participante: null,
              id_participante_poster: null,
            })
            this.autor = Object.assign(
              this.autor,
              omit(this.defaultAutor, ['dni'])
            )
            this.reset()
          }

          this.visible = !this.instituciones.some(
            e => e.text === data.institucion
          )
          if (this.visible) {
            this.instSelected = 'Otra'
            this.autor.institucion = data.institucion
          } else {
            this.instSelected = data.institucion
            this.autor.institucion = data.institucion
          }
          this.disable = true
        })
        .catch(() => {
          this.disable = false
        })
        .finally(() => {
          this.working = false
        })
    },

    async editAuthor(item) {
      this.disable = !!item.id_participante || !!item.id_participante_poster

      this.index = this.autores.indexOf(item)
      this.autor = Object.assign({}, item)
      this.visible = !this.instituciones.some(e => e.text === item.institucion)
      if (this.visible) {
        this.instSelected = 'Otra'
        this.autor.institucion = item.institucion
      } else {
        this.instSelected = item.institucion
        this.autor.institucion = item.institucion
      }
      this.dialog = true
    },

    deleteItem(item) {
      const index = this.autores.indexOf(item)
      this.autores.splice(index, 1)
    },

    close() {
      this.dialog = false
      this.autor = Object.assign({}, this.defaultAutor)
      this.index = -1
      this.disable = true
      this.instSelected = null
    },

    newAuthor() {
      this.dialog = true
      this.autor.asesor = null
      this.reset()
      // this.autocomplite()
    },

    // newAsesor() {
    //   this.dialog = true
    //   this.autor.asesor = true
    //   this.reset()
    //   // this.autocomplite()
    // },

    async save() {
      if (this.index > -1) {
        Object.assign(this.autores[this.index], this.autor)
      } else {
        if (await this.verifyEmail(this.autor.email)) return
        if (this.verifyAutor(this.autor.dni)) return
        if (this.autor.asesor) {
          this.autores.splice(1, 0, this.autor)
        } else {
          this.autores.push(this.autor)
        }
      }
      this.close()
    },
    open() {
      this.visible = false
      this.dialog = true
      this.reset()
    },

    reset() {
      Object.keys(this.autor).forEach(k => {
        !this.$refs[k] || this.$refs[k].resetValidation()
      })
      !this.$refs['instSelected'] ||
        this.$refs['instSelected'].resetValidation()
    },

    openAlert(icon, title, call = null) {
      Swal.fire({ title, icon }).then(() => {
        if (call) call()
      })
    },
    async verifyEmail(v) {
      if (/.+@.+\..+/.test(v)) {
        const { id_participante } = await participanteService.searchEmail(v)
        if (this.autor.id_participante) {
          if (id_participante !== this.autor.id_participante) {
            this.exist = 'El email ya está siendo usado'
            return true
          } else {
            this.exist = null
            return false
          }
        } else {
          if (
            this.autores.some(
              e => e.email.toLocaleLowerCase() === v.toLocaleLowerCase()
            ) ||
            !!id_participante
          ) {
            this.exist = 'El email ya está siendo usado'
            return true
          } else {
            this.exist = null
            return false
          }
        }
      } else {
        this.exist = null
        return false
      }
    },
    verifyAutor(dni) {
      if (this.autores.some(e => e.dni == dni)) {
        this.duplicate = 'Ya has añadido este autor'
        return true
      } else {
        this.duplicate = null
        return false
      }
    },
  },
}
</script>
